import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { DeleteScoutingCampaignButton } from './DeleteScoutingCampaignButton.component'
import { ScoutingCampaign } from '../../../../../../../entities-next/scoutingCampaign'

export type ScoutingCampaignTableActionsProps = ExtendableStyles &
  Testable & {
    scoutingCampaign: ScoutingCampaign
  }

export function ScoutingCampaignTableActions({ className, scoutingCampaign }: ScoutingCampaignTableActionsProps) {
  const { classes } = useStyles()

  return (
    <div className={classNames(className, classes.actionCell)}>
      <DeleteScoutingCampaignButton className={classes.actionButton} scoutingCampaign={scoutingCampaign} />
    </div>
  )
}

const useStyles = makeStyles()(({ palette, spacing }) => ({
  actionCell: {
    display: 'flex',
    alignItems: 'center',
  },
  actionButton: {
    width: spacing(5.5),
    height: spacing(5.5),
  },
  testingUserChip: {
    marginRight: spacing(-0.5),
    color: palette.common.white,
    backgroundColor: palette.primary.main,
  },
}))
